import { createStore, combineReducers, applyMiddleware } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage";

import auth from "./auth";

/**
 * Initialise le store de l'application pour la gestion de l'état.
 */
export default function setup() {
  const store = createStore(
    persistReducer(
      {
        key: "root",
        storage,
      },
      combineReducers({
        auth,
      }),
    ),
    composeWithDevTools(applyMiddleware(thunk)),
  );
  const persistor = persistStore(store);

  return { store, persistor };
}
